import {importProvidersFrom} from '@angular/core';
import {AppComponent, MY_DATE_FORMAT} from './app/components/app.component';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatLineModule,
  provideNativeDateAdapter
} from '@angular/material/core';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AuthModule} from './app/shared/auth/auth.module';
import {provideAnimations} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app/app-routing.module';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async'
import {CustomMatPaginator} from './app/shared/custom-mat-paginator/CustomMatPaginator'
import {NgxPermissionsModule} from 'ngx-permissions';
import {MomentDateAdapter} from "@angular/material-moment-adapter";
import {TitleStrategy} from "@angular/router";
import {AppTitleStrategy} from "./app/app.title.strategy";

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, AuthModule, MatSidenavModule, MatToolbarModule, MatFormFieldModule, MatSelectModule, MatIconModule, MatButtonModule, MatListModule, MatLineModule, NgxPermissionsModule.forRoot()),
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    provideNativeDateAdapter(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    {provide: MatPaginatorIntl, useClass: CustomMatPaginator}, provideAnimationsAsync(),
    {
      provide: TitleStrategy,
      useClass: AppTitleStrategy
    },
  ]
})
  .catch(err => console.error(err));
